import { UserRoles } from "@vellum/vellum-api";

/** Roles a link, report, or flag can be restricted to. Facility is intentionally excluded. */
export const VISIBILITY_ROLES: UserRoles[] = [
  UserRoles.ADMIN,
  UserRoles.REGION_ADMIN,
  UserRoles.NURSE,
  UserRoles.TRIAGE_NURSE,
  UserRoles.FIELD_NURSE,
];

/** Display order for summaries — includes roles no longer selectable. */
const DISPLAY_ORDER: UserRoles[] = [...VISIBILITY_ROLES, UserRoles.FACILITY];

/**
 * How a restriction reads in a summary. An empty array means everyone sees it
 * — the rule the "Everyone" wording keeps explicit.
 */
export function describeVisibility(roles: string[] | undefined): string {
  if (!roles || roles.length === 0) {
    return "Everyone";
  }

  return DISPLAY_ORDER.filter((role) => roles.includes(role)).join(", ");
}
